export default __webpack_public_path__ + "static/media/nav_img_13.d7ca7f62.jpg";